module.exports = __webpack_public_path__ + "static/media/logo-alkomprar-header.fef0af18.png";